var video1 = promokit.youtube({
    el: '#player-1',
    youtubeid: 'Z8wgNrIDCQM',
    preload: true,
    controls: true,
    youtubeLink:true
});

var layer1 = promokit.layer({
    el: '#layer-1',
    render: true,
    autoplayVideo: video1
});

$(document).on('click', '.p-header__play', function() {
    layer1.open();
});

layer1.on('ready', () => {
    // console.log('ready');
});


(function () {
    'use strict';
    window.addEventListener('load', function() {
        var canvas = document.getElementById('canvas');

        if (!canvas || !canvas.getContext) {
            return false;
        }

        /********************
         Random Number
         ********************/

        function rand(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        /********************
         Var
         ********************/

            // canvas
        var ctx = canvas.getContext('2d');
        var X = canvas.width = window.innerWidth - 17;
        // var X = canvas.width = $(window).width();
        var Y = canvas.height = window.innerHeight - 17;
        if(X < 1100) $('#canvas').hide();
        var mouseX;
        var mouseY;

        /********************
         Animation
         ********************/

        window.requestAnimationFrame =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(cb) {
                setTimeout(cb, 17);
            };

        /********************
         Cloud
         ********************/

        var cloudNum = 200;
        var clouds = [];
        var radiusMin = 150;
        var radiusMax = 300;

        if (X < 768) {
            cloudNum = 100;
            radiusMin = 100;
            radiusMax = 150;
        }

        function Cloud(ctx, x, y) {
            this.ctx = ctx;
            this.init(x, y);
        }

        Cloud.prototype.init = function(x, y) {
            this.x = x;
            this.y = y;
            this.r = rand(radiusMin, radiusMax);
            this.l = rand(50, 100);
            this.v = {
                x: rand(-2, 2) * Math.random(),
                y: rand(-2, 2) * Math.random()
            };
            this.c = {
                r: rand(0, 255),
                g: rand(0, 255),
                b: rand(0, 255),
                a: 1
            };
        };

        Cloud.prototype.wrapPosition = function() {
            if (this.x + this.r < 0) {
                this.x = X + this.r;
            }
            if (this.x - this.r > X) {
                this.x = 0 - this.r;
            }
            if (this.y + this.r < 0) {
                this.y = Y + this.r;
            }
            if (this.y - this.r > Y) {
                this.y = 0 - this.r;
            }
        };

        Cloud.prototype.updatePosition = function() {
            this.x += this.v.x;
            this.y += this.v.y;
        };

        Cloud.prototype.updateParams = function() {
            this.l -= 0.1;
            if (this.l < 0) {
                this.v.x = rand(-2, 2) * Math.random();
                this.v.y = rand(-2, 2) * Math.random();
                this.l = rand(50, 100);
            }
        };

        Cloud.prototype.resize = function() {
            this.x = rand(0 - 100, X + 100);
            this.y = rand(0 - 100, Y + 100);
        };

        Cloud.prototype.render = function() {
            this.updatePosition();
            this.updateParams();
            this.wrapPosition();
            this.draw();
        };

        Cloud.prototype.gradient = function () {
            var col = this.c.r + "," + this.c.g + "," + this.c.b;
            var g = this.ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.r);
            g.addColorStop(0, "rgba(34,115,69,0.78)");
            g.addColorStop(0.33, "rgba(19,64,35,0.52)");
            g.addColorStop(0.66, "rgba(13,7,4,0.26)");
            g.addColorStop(1, "rgba(0,0,0,0)");
            // g.addColorStop(0, "rgba(39,140,75,0.7)");
            // 제일 진한 smoke
/*
            g.addColorStop(0, "rgba(39,140,75,1)");
            g.addColorStop(0.25, "rgba(34,115,69,0.75)");
            g.addColorStop(0.5, "rgba(19,64,35,0.5)");
            g.addColorStop(0.75, "rgba(13,7,4,0.25)");
            g.addColorStop(1, "rgba(0,0,0,0)");
*/
            return g;
        };

        Cloud.prototype.draw = function() {
            ctx.save();
            ctx.beginPath();
            ctx.globalCompositeOperation = 'lighter';
            ctx.globalAlpha = 0.1;
            ctx.fillStyle = this.gradient();
            ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
            ctx.fill();
            ctx.restore();
        };

        for (var i = 0; i < cloudNum; i++) {
            var cloud = new Cloud(ctx, rand(0 -100, X + 100), rand(0 - 100, Y + 100));
            clouds.push(cloud);
        }

        /********************
         Render
         ********************/

        function changeColor() {
            var time = rand(1000, 5000);
            var r = rand(0, 255);
            var g = rand(0, 255);
            var b = rand(0, 255);
            for (var i = 0; i < clouds.length; i++) {
                clouds[i].c  = {
                    r: r,
                    g: g,
                    b: b,
                    a: 1
                };
            }
            setTimeout(changeColor, time);
        }

        changeColor();

        /********************
         Render
         ********************/

        function render(){
            ctx.clearRect(0, 0, X, Y);
            for (var i = 0; i < clouds.length; i++) {
                clouds[i].render();
            }
            requestAnimationFrame(render);
        }

        render();

        /********************
         Event
         ********************/

        // resize
        function onResize() {
            X = canvas.width = window.innerWidth - 17;
            Y = canvas.height = window.innerHeight - 17;
            if(X < 1100) $('#canvas').hide();
            if (X < 768) {
                cloudNum = 200;
            } else {
                cloudNum = 100;
            }
            for (var i = 0; i < clouds.length; i++) {
                clouds[i].resize();
            }
        }

        window.addEventListener('resize', function() {
            onResize();
        });

        /*
                window.addEventListener('mousemove', function(e) {
                    mouseX = e.clientX;
                    mouseY = e.clientY;
                });
        */

    });
    // Author
    // console.log('File Name / fog.js\nCreated Date / May 14, 2020\nAuthor / Toshiya Marukubo\nTwitter / https://twitter.com/toshiyamarukubo');
})();

export default {
    id: '#section-header'
};



// WEBPACK FOOTER //
// ./src/js/PC/main.js